/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingQueryTransactionType extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MasterAccountBillingQueryTransactionType");
    }

    getFixupPrototypeFunction() { return MasterAccountBillingQueryTransactionType.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingQueryTransactionType>): MasterAccountBillingQueryTransactionType {
        let obj = Object.assign(new MasterAccountBillingQueryTransactionType(), model);
        MasterAccountBillingQueryTransactionType.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingQueryTransactionType>): MasterAccountBillingQueryTransactionType {
        if (!model) return null;
        return MasterAccountBillingQueryTransactionType.newInstance(<MasterAccountBillingQueryTransactionType> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingQueryTransactionType) {
        if (!obj) return;

        models.MasterAccountBillingQueryTransactionType.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingQueryTransactionType): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MasterAccountBillingQueryTransactionType.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type of the Transaction
     */
    transaction_types: Array<models.BillingTransactionType>;

}
